import React from 'react';
import moment from 'moment';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button
  // IconButton
} from '@material-ui/core';
import {
  ExpandMore as ExpandMoreIcon
  // Create as CreateIcon
} from '@material-ui/icons';

let styles = {
  headerGobackStyle: {
    color: '#1d1e81',
    border: '1px solid',
    borderRadius: '50%',
    padding: 0,
    margin: '0 0 1px 0',
    cursor: 'pointer'
  },
  bodyGobackStyle: {
    color: '#f58200',
    border: '1px solid',
    borderRadius: '50%',
    padding: 0,
    margin: '0 0 1px 0',
    cursor: 'pointer'
  },
  editButton: {
    minWidth: '36px',
    top: '-10px',
    float: 'right',
    marginRight: '20px',
    fontSize: '10px'
    // backgroundColor: '#f58200'
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline'
  }
};

class Summary extends React.Component {
  render() {
    const { formdata, stateconfig, networkconfig, jumpTo, inStates } = this.props;

    const backTo = (id, bounce, key, value) => false && jumpTo(id, false, key, value);

    const goBackTo = (id, bounce, key, value) => jumpTo(id, false, key, value);

    const goBack = (id, bounce = true, key = null, value = null, style = 'editButton') => (
      <Button
        color="primary"
        style={styles[style]}
        onClick={() => goBackTo(id, bounce, key, value)}
        component="span">
        Edit
      </Button>
    );

    const getHomeAddress = (data, app) => {
      if (!app.home)
        return data.hqaddress && data.hqaddress.description
          ? data.hqaddress.description
          : data.home;
      return app.home.description || app.home;
    };

    const getPostalAddress = (data, app) => {
      let home = getHomeAddress(data, app);
      return app.home_as_postal
        ? home && home.description
          ? home.description
          : home
        : app.postal && app.postal.description
        ? app.postal.description
        : app.postal;
    };

    const getKinAddress = (data, app) => {
      let home = getHomeAddress(data, app);
      return app.home_as_kin
        ? home && home.description
          ? home.description
          : home
        : app.kin_address && app.kin_address.description
        ? app.kin_address.description
        : app.kin_address;
    };

    return (
      <Grid container>
        <Grid item xs={12} lg={6}>
          <Paper variant="outlined" className="application" elevation={0}>
            <h2 className="pointerCursor" onClick={() => backTo('network', true)}>
              Network Details
            </h2>
            <Grid container>
              <Grid item xs={12} sm={6} onClick={() => backTo('state', true)}>
                <label>State:</label> {formdata.state ? stateconfig().label : ''}{' '}
              </Grid>
              <Grid item xs={12} sm={6} onClick={() => backTo('network', true)}>
                <label>Network:</label> {formdata.network}
              </Grid>
              <Grid item xs={12} sm={6} onClick={() => backTo('network', true)}>
                <label>Region:</label> {formdata.region}
              </Grid>
              <Grid
                style={styles.link}
                item
                xs={12}
                sm={6}
                onClick={() => goBackTo('m7details', true)}>
                <label style={styles.link}>M7 Account: </label>
                {formdata.m7_account ? formdata.m7_account : 'No'}
              </Grid>
              <Grid
                style={styles.link}
                item
                xs={12}
                sm={6}
                onClick={() => goBackTo('currop', true)}>
                <label style={styles.link}>Current {formdata.network} Operator: </label>
                {formdata.currop ? 'Yes' : 'No'}
              </Grid>
              {networkconfig().tiger && !inStates(['nsw']) ? (
                <Grid item xs={12} sm={6}>
                  <label>Rent Vehicle from 13cabs:</label> {formdata.tiger ? 'Yes' : 'No'}
                </Grid>
              ) : (
                ''
              )}
              {!formdata.currop ? (
                <>
                  <Grid style={styles.link} item xs={6} onClick={() => goBackTo('prevnet', true)}>
                    <label style={styles.link}>Current Network: </label>
                    {!formdata.currentnetwork || formdata.currentnetwork === 'Other'
                      ? formdata.currentnetwork_text
                      : formdata.currentnetwork}
                  </Grid>
                  <Grid style={styles.link} item xs={12} onClick={() => goBackTo('prevnet', true)}>
                    <label style={styles.link}>Reason for Leaving: </label>
                    {formdata.currentnetwork_reason === 'Other'
                      ? formdata.currentnetwork_reason_other
                      : formdata.currentnetwork_reason}
                  </Grid>
                </>
              ) : (
                ''
              )}
            </Grid>
          </Paper>
        </Grid>
        {formdata.onboardingFor !== 'vehicle' && (
          <Grid item xs={12} sm={6}>
            <Paper
              variant="outlined"
              className="bank"
              onClick={() => backTo('bank', true)}
              elevation={0}>
              <h2>Bank Details {goBack('bank')}</h2>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <label>Bank:</label> {formdata.bank}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>BSB:</label> {formdata.bsb}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>Account Name:</label> {formdata.account}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>Account Number:</label> {formdata.accountnum}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}

        {formdata.orgtype === 'company' || formdata.orgtype === 'partnership' ? (
          <Grid item xs={12} sm={6}>
            <Paper
              variant="outlined"
              className="company"
              onClick={() => backTo('company', true)}
              elevation={0}>
              <h2>
                {formdata.orgtype === 'company' ? 'Company' : 'Partnership'} Details{' '}
                {goBack('company')}
              </h2>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <label>Name:</label> {formdata.orgname}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>Trading As:</label> {formdata.trading_as}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>ABN:</label> {formdata.orgabn}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>ACN:</label> {formdata.acn}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>Registered for GST:</label> {formdata.gst ? 'Yes' : 'No'}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>Phone:</label> {formdata.orgphone}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>Email:</label> {formdata.orgemail}
                </Grid>
                {formdata.org_crn ? (
                  <Grid item xs={12} sm={6}>
                    <label>CRN:</label> {formdata.org_crn}
                  </Grid>
                ) : (
                  ''
                )}
                <Grid item xs={12}>
                  <label>Correspondance Name: </label>
                  {formdata.name_as_correspondance ? formdata.orgname : formdata.correspondname}
                </Grid>
                <Grid item xs={12}>
                  <label>Registered Address: </label>
                  {formdata.hqaddress && formdata.hqaddress.description
                    ? formdata.hqaddress.description
                    : formdata.hqaddress}
                </Grid>
                <Grid item xs={12}>
                  <label>Operational Address: </label>
                  {formdata.op_as_hq
                    ? formdata.hqaddress && formdata.hqaddress.description
                      ? formdata.hqaddress.description
                      : formdata.hqaddress
                    : formdata.opaddress && formdata.opaddress.description
                    ? formdata.opaddress.description
                    : formdata.opaddress}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        ) : (
          ''
        )}
        {formdata.relent ? (
          <Grid item xs={12} sm={6}>
            <Paper variant="outlined" onClick={() => backTo('relatedorgs')}>
              <h2>Related Entities {goBack('relatedorgs')}</h2>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Company</TableCell>
                    <TableCell>ACN</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {formdata.relent.map((relent, i) => (
                    <TableRow key={i}>
                      <TableCell>{relent.name}</TableCell>
                      <TableCell>{relent.acn}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        ) : (
          ''
        )}
        <Grid item xs={12} sm={6}>
          <Paper variant="outlined" className="applicants" elevation={0}>
            <h2 className="pointerCursor" onClick={() => backTo('partners')}>
              Applicants {goBack('partners')}
            </h2>
            {formdata.applicants.map((app, i) => (
              <React.Fragment key={i}>
                <Accordion elevation={0}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    {app.title +
                      ' ' +
                      app.firstname +
                      (app.othername ? ' ' + app.othername : '') +
                      ' ' +
                      app.surname}
                  </AccordionSummary>
                  <AccordionDetails>
                    <h5
                      className="pointerCursor"
                      onClick={() => backTo('personal', true, 'applicant_index', i)}>
                      Personal Details {goBack('personal', true, 'applicant_index', i)}
                    </h5>
                    <Grid container>
                      <Grid item xs={12} sm={6}>
                        <label>Email:</label> {app.email}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <label>Mobile:</label> {app.mobile}
                      </Grid>
                      {app.onboardingFor !== 'vehicle' && (
                        <>
                          <Grid item xs={12} sm={6}>
                            <label>Place of Birth:</label> {app.placeofbirth}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <label>Home Address:</label> {getHomeAddress(formdata, app)}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <label>Postal Address:</label> {getPostalAddress(formdata, app)}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <label>ABN:</label> {app.abn}
                          </Grid>
                          {app.crn ? (
                            <Grid item xs={12} sm={6}>
                              <label>CRN:</label> {app.crn}
                            </Grid>
                          ) : (
                            ''
                          )}
                        </>
                      )}

                      {app.identity
                        ? Object.keys(app.identity).map((k) => (
                            <Grid key={k} item xs={12} sm={6}>
                              <label>{k}: </label>
                              <img src={app.identity[k].image.contents} alt={k} width={120} />
                            </Grid>
                          ))
                        : ''}
                    </Grid>
                    {app.owneroperator ? (
                      <>
                        <h5
                          className="pointerCursor"
                          onClick={() => backTo('kin', true, 'applicant_index', i)}>
                          Next of Kin {goBack('kin', true, 'applicant_index', i)}
                        </h5>
                        <Grid container>
                          <Grid item xs={12} sm={6}>
                            <label>Name:</label> {app.kin_name}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <label>Relationship:</label> {app.kin_relationship}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <label>Phone:</label> {app.kin_phone}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <label>Address:</label> {getKinAddress(formdata, app)}
                          </Grid>
                        </Grid>
                        <h5
                          className="pointerCursor"
                          onClick={() => backTo('driverdetails', true, 'applicant_index', i)}>
                          Driver Details {goBack('driverdetails', true, 'applicant_index', i)}
                        </h5>
                        <Grid container>
                          {stateconfig().drivercred ? (
                            <>
                              <Grid item xs={12} sm={6}>
                                <label>Driver ID:</label> {app.driveraccred}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Driver PIN:</label> {app.driverpin}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Driver Accreditation Expiry: </label>
                                {moment(app.driveraccred_date).format('DD/MM/YYYY')}
                              </Grid>
                            </>
                          ) : (
                            ''
                          )}
                          {/* <Grid item xs={ 3 / app_size }><label>Spotto:</label> { app.spotto ? 'Yes' : 'No' }</Grid> */}
                          <Grid item xs={12} sm={6}>
                            <label>Driving:</label> {app.owneroperator ? 'Yes' : 'No'}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <label>Cabcharge Equipment:</label> {app.cabequip ? 'Yes' : 'No'}
                          </Grid>
                          {app.cabequip ? (
                            <Grid item xs={12} sm={6}>
                              <label>Terminal ID:</label> {app.terminalid}
                            </Grid>
                          ) : (
                            ''
                          )}
                          {app.drivercred ? (
                            <Grid item xs={12} sm={6}>
                              <label>Driver Accreditation: </label>
                              <img
                                src={app.drivercred.contents}
                                alt={'Driver Accreditation'}
                                width={120}
                              />
                            </Grid>
                          ) : (
                            ''
                          )}
                        </Grid>
                      </>
                    ) : (
                      ''
                    )}
                    {app.onboardingFor !== 'vehicle' && (
                      <>
                        {' '}
                        <h5
                          className="pointerCursor"
                          onClick={() => backTo('licence', true, 'applicant_index', i)}>
                          Licences {goBack('licence', true, 'applicant_index', i)}
                        </h5>
                        <Grid container>
                          <Grid item xs={12} sm={6}>
                            <label>Driver&apos;s Licence #:</label> {app.licno}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <label>Expiry:</label> {moment(app.licexp).format('DD/MM/YYYY')}
                          </Grid>
                          {formdata.taxiauth ? (
                            <>
                              <Grid item xs={12} sm={6}>
                                <label>Taxi Authority #:</label> {app.taxiauth}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Expiry:</label> {moment(app.taxiexp).format('DD/MM/YYYY')}
                              </Grid>
                            </>
                          ) : (
                            ''
                          )}

                          {app.driverstateaccred && (
                            <Grid item xs={12} sm={6}>
                              <label>{stateconfig().driverstatecred + ' Number: '}</label>
                              {app.driverstateaccred}
                            </Grid>
                          )}

                          {app.driverstateaccred_date && (
                            <Grid item xs={12} sm={6}>
                              <label>{stateconfig().driverstatecred + ' Expiry: '}</label>
                              {moment(app.driverstateaccred_date).format('DD/MM/YYYY')}
                            </Grid>
                          )}

                          {app.licfront && (
                            <Grid item xs={12} sm={6}>
                              <label>Licence - Front: </label>
                              <img src={app.licfront.contents} alt="Licence - Front" width={120} />
                            </Grid>
                          )}

                          {app.licback && (
                            <Grid item xs={12} sm={6}>
                              <label>Licence - Back:</label>{' '}
                              <img src={app.licback.contents} alt="Licence - Back" width={120} />
                            </Grid>
                          )}

                          {app.driverstatecred && (
                            <Grid item xs={12} sm={6}>
                              <label>{stateconfig().driverstatecred + ' Certificate: '}</label>
                              <img
                                src={app.driverstatecred.contents}
                                alt={stateconfig().driverstatecred + ' Certificate'}
                                width={120}
                              />
                            </Grid>
                          )}
                          {app.driverstatecredback && (
                            <Grid item xs={12} sm={6}>
                              <label>
                                {stateconfig().driverstatecred + ' Certificate - Back: '}
                              </label>
                              <img
                                src={app.driverstatecredback.contents}
                                alt="Licence - Back"
                                width={120}
                              />
                            </Grid>
                          )}
                        </Grid>
                      </>
                    )}
                    {(
                      <>
                        {' '}
                        <h5
                          className="pointerCursor"
                          onClick={() => backTo('paymenttermstep', true, 'applicant_index', i)}>
                          Payment Period {goBack('paymenttermstep', true, 'applicant_index', i)}
                        </h5>
                        <container>
                          <Grid item xs={12} sm={6}>
                            <label>Payment Cycle:</label> {formdata.paymentcycle}
                          </Grid>
                          {stateconfig().securitydeposit ? (<><Grid item xs={12} sm={6}>
                            <label>Security Deposit:</label> {formdata.securitydeposit}
                          </Grid></>) : ('')}                          
                          </container>
                          </>
                    )}
                  </AccordionDetails>
                </Accordion>
              </React.Fragment>
            ))}
          </Paper>
        </Grid>
        {formdata.tiger || !formdata.onboardcar ? null : (
          <Grid item xs={12} sm={6}>
            <Paper variant="outlined" className="vehicles" elevation={0}>
              <h2 onClick={() => backTo('vehiclesummary')}>Vehicles {goBack('vehiclesummary')}</h2>
              {formdata.vehicles.map((car, i) => (
                <React.Fragment key={i}>
                  <Accordion elevation={0}>
                    <AccordionSummary
                      expandIcon={
                        (stateconfig().oldcar && car.car_replace) ||
                        car.carfin ||
                        car.carbuy ||
                        !car.carfin ||
                        !car.carbuy ||
                        car.plate === 'other' ? (
                          <ExpandMoreIcon />
                        ) : null
                      }>
                      <Grid container>
                        <Grid item xs={12}>
                          <label>
                            {car.carbuy && 'Vehicle provided by: ' + formdata.network}
                            {formdata.state && stateconfig().colour
                              ? stateconfig().colour
                              : networkconfig().colour
                              ? networkconfig().colour
                              : car.colour}{' '}
                            {car.make === 'Other' ? car.makeother : car.make}{' '}
                            {car.model === 'Other' || car.make === 'Other'
                              ? car.modelother
                              : car.model}
                          </label>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    {(stateconfig().oldcar && car.car_replace) ||
                    car.carfin ||
                    car.carbuy ||
                    !car.carfin ||
                    !car.carbuy ||
                    car.plate === 'other' ? (
                      <AccordionDetails>
                        {!formdata.tiger && !car.carbuy ? (
                          <>
                            <Grid container>
                              {car.plateOwnership && (
                                <Grid item xs={12} sm={6}>
                                  <label>Plate Owner: </label> {car.plateOwnership || 'own'}
                                </Grid>
                              )}
                              <Grid item xs={12} sm={6}>
                                <label>VIN:</label> {car.vin}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Manufactured:</label> {moment(car.date).format('MMMM, YYYY')}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Fuel Type:</label> {car.fueltype}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Previously Fitted Out: </label>
                                {car.previously_fittedout ? 'Yes' : 'No'}
                              </Grid>
                            </Grid>
                            <h5>Seating</h5>
                            <Grid container>
                              {car.vehicle_seats ? (
                                <Grid item xs={6}>
                                  <label>Seats:</label> {car.vehicle_seats}
                                </Grid>
                              ) : (
                                ''
                              )}
                              {car.vehicle_frontseats ? (
                                <Grid item xs={6}>
                                  <label>Front Seats:</label> {car.vehicle_frontseats}
                                </Grid>
                              ) : (
                                ''
                              )}
                              {car.vehicle_rearseats ? (
                                <Grid item xs={6}>
                                  <label>Rear Seats:</label> {car.vehicle_rearseats}
                                </Grid>
                              ) : (
                                ''
                              )}
                              <Grid item xs={6}>
                                <label>Kids Seats:</label> {car.vehicle_kids}
                              </Grid>
                              <Grid item xs={6}>
                                <label>Baby Capsules:</label> {car.vehicle_babies}
                              </Grid>
                              {car.wats ? (
                                <Grid item xs={6}>
                                  <label>Wheelchairs:</label> {car.wheelchairs}
                                </Grid>
                              ) : (
                                ''
                              )}
                            </Grid>
                            <h5>Cameras</h5>
                            <Grid container>
                              <Grid item xs={12}>
                                <label>Model: </label>
                                {car.camera === true
                                  ? 'Provided by ' + formdata.network
                                  : car.cammodel}
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          ''
                        )}
                        {stateconfig().oldcar && car.car_replace ? (
                          <>
                            <h5>Previous Vehicle</h5>
                            <Grid container>
                              <Grid item xs={12} sm={6}>
                                <label>Registration:</label> {car.old_rego}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Manufacture Date: </label>
                                {moment(car.old_manudate).format('MMMM, YYYY')}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Make:</label> {car.old_make}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Model:</label> {car.old_model}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Shape:</label> {car.old_shape}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>On-Road Date:</label>{' '}
                                {moment(car.old_onroad).format('DD/MM/YYYY')}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Lease Type:</label> {car.old_lease}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Lease End Date:</label>{' '}
                                {moment(car.old_leaseend).format('DD/MM/YYYY')}
                              </Grid>

                              <Grid item xs={car.old_wats ? 4 : 6}>
                                <label>Front Seats: </label> {car.old_frontseats}
                              </Grid>
                              <Grid item xs={car.old_wats ? 4 : 6}>
                                <label>Rear Seats: </label> {car.old_rearseats}
                              </Grid>
                              {car.old_wats ? (
                                <Grid item xs={4}>
                                  <label>Wheelchairs: </label> {car.old_wheelchairs}
                                </Grid>
                              ) : (
                                ''
                              )}
                            </Grid>
                          </>
                        ) : (
                          ''
                        )}
                        {car.carfin && !car.carbuy ? (
                          <>
                            <h5>Vehicle Provider</h5>
                            <Grid container>
                              <Grid item xs={12} sm={6}>
                                <label>Name:</label> {car.carbuy_name}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Phone:</label> {car.carbuy_phone}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Registered for GST:</label> {car.carbuy_gst ? 'Yes' : 'No'}
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          ''
                        )}
                        {car.carbuy && !car.carfin ? (
                          <>
                            <h5>Finance Provider</h5>
                            <Grid container>
                              <Grid item xs={12} sm={6}>
                                <label>Business:</label> {car.carfin_busname}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Name:</label> {car.carfin_name}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Phone:</label> {car.carfin_phone}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Registered for GST:</label> {car.carfin_gst ? 'Yes' : 'No'}
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          ''
                        )}
                        {true ? (
                          <>
                            <h5>Accreditation</h5>
                            <Grid container>
                              {car.taxiauth ? (
                                <Grid item xs={12} sm={6}>
                                  <label>Licence:</label> {car.taxiauth}
                                </Grid>
                              ) : (
                                ''
                              )}
                              {car.taxiexp ? (
                                <Grid item xs={12} sm={6}>
                                  <label>Expiry:</label> {moment(car.taxiexp).format('DD/MM/YYYY')}
                                </Grid>
                              ) : (
                                ''
                              )}

                              <Grid item xs={12} sm={6}>
                                <label>Plate Owner: </label>
                                {car.plateOwnership}
                              </Grid>

                              {car.plate_number && (
                                <>
                                  <Grid item xs={12} sm={6}>
                                    <label>{stateconfig().plateName}: </label>
                                    {car.plate_number}
                                  </Grid>
                                  {car.plate_exp && (
                                    <Grid item xs={12} sm={6}>
                                      <label>{stateconfig().plateName} Expiry: </label>
                                      {moment(car.plate_exp).format('DD/MM/YYYY')}
                                    </Grid>
                                  )}
                                </>
                              )}

                              {car.auth_number && (
                                <>
                                  <Grid item xs={12} sm={6}>
                                    <label>{stateconfig().authName}: </label>
                                    {car.auth_number}
                                  </Grid>
                                  {car.auth_exp && (
                                    <Grid item xs={12} sm={6}>
                                      <label>{stateconfig().authName} Expiry: </label>
                                      {moment(car.auth_exp).format('DD/MM/YYYY')}
                                    </Grid>
                                  )}
                                </>
                              )}
                            </Grid>
                          </>
                        ) : (
                          ''
                        )}
                        {car.plate === 'other' ? (
                          <>
                            <h5>Plate Holder</h5>
                            <Grid container>
                              <Grid item xs={12} sm={6}>
                                <label>Name:</label> {car.plate_owner_name}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Address:</label>{' '}
                                {car.plate_address && car.plate_address.description
                                  ? car.plate_address.description
                                  : car.plate_address}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>ACN/ABN:</label> {car.plate_owner_acn_abn}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label>Registered for GST:</label> {car.plate_gst ? 'Yes' : 'No'}
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          ''
                        )}
                        {car.policynumber || car.cabsure ? (
                          <>
                            <h5>Insurance Details</h5>
                            <Grid container>
                              {car.policynumber ? (
                                <>
                                  <Grid item xs={12} sm={6}>
                                    <label>Policy #:</label> {car.policynumber}
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <label>Expiry Date: </label>
                                    {moment(car.policyexp).format('DD/MM/YYYY')}
                                  </Grid>
                                </>
                              ) : (
                                ''
                              )}

                              <Grid item xs={12} sm={6}>
                                <label>Cabsure Quote Requested: </label>
                                {car.cabsure ? 'Yes' : 'No'}
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          ''
                        )}
                        {!formdata.tiger && !car.carbuy ? (
                          <>
                            <h5>Certificates</h5>
                            <Grid container>
                              {car.roadworthy ? (
                                <Grid item xs={12} sm={6}>
                                  <label>Roadworthiness: </label>
                                  <img
                                    src={car.roadworthy.contents}
                                    alt="Roadworthiness Certificate"
                                    width={120}
                                  />
                                </Grid>
                              ) : (
                                ''
                              )}
                              {car.ctp_coc ? (
                                <Grid item xs={12} sm={6}>
                                  <label>CTP:</label>{' '}
                                  <img
                                    src={car.ctp_coc.contents}
                                    alt="CTP Certificate of Currency"
                                    width={120}
                                  />
                                </Grid>
                              ) : (
                                ''
                              )}
                              {car.registration ? (
                                <Grid item xs={12} sm={6}>
                                  <label>Registration:</label>{' '}
                                  <img
                                    src={car.registration.contents}
                                    alt="Registration"
                                    width={120}
                                  />
                                </Grid>
                              ) : (
                                ''
                              )}
                              {car.plate_cert ? (
                                <Grid item xs={12} sm={6}>
                                  <label>Plate:</label>{' '}
                                  <img
                                    src={car.plate_cert.contents}
                                    alt="Plate Certificate"
                                    width={120}
                                  />
                                </Grid>
                              ) : (
                                ''
                              )}

                              {car.auth_cert ? (
                                <Grid item xs={6}>
                                  <label>Authorization: </label>
                                  <img
                                    src={car.auth_cert.contents}
                                    alt="Authorization Certificate"
                                    width={120}
                                  />
                                </Grid>
                              ) : (
                                ''
                              )}
                              {car.wats ? (
                                <Grid item xs={12} sm={6}>
                                  <label>WATS:</label> {car.wats_cred}
                                  <img
                                    src={car.wats_image.contents}
                                    alt="WATS Certificate"
                                    width={120}
                                  />
                                </Grid>
                              ) : (
                                ''
                              )}
                            </Grid>
                          </>
                        ) : (
                          ''
                        )}
                      </AccordionDetails>
                    ) : (
                      ''
                    )}
                  </Accordion>
                </React.Fragment>
              ))}
            </Paper>
          </Grid>
        )}
      </Grid>
    );
  }
}

export default Summary;
